export default __webpack_public_path__ + "static/media/ico-delete-grey.30294f9d.svg";